class ScrollNumber extends HTMLElement {
    constructor() {
        super();
        this.hasAnimated = false;
        this.observer = null;
    }

    connectedCallback() {

        this.numberContainer = this.querySelector('.number');
        this.unitContainer = this.querySelector('.unit');
        this.number = parseInt(this.dataset.number) || 0;


        if (!this.numberContainer) {
            return;
        }

        // 不要在这里清空numberContainer，让createRollingNumber来处理
        // this.numberContainer.innerHTML = '';

        // 立即检查motion-element状态，然后开始监听
        this.checkMotionElementState();
        this.observeParentOpacity();
    }

    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    observeParentOpacity() {
        // 查找motion-element子元素
        const motionElement = this.querySelector('motion-element');
        if (!motionElement) {
            return;
        }


        // 监听motion-element的data-initialized属性变化
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'data-initialized') {
                    this.checkMotionElementState();
                }
            });
        });

        this.observer.observe(motionElement, {
            attributes: true,
            attributeFilter: ['data-initialized']
        });
    }

    checkMotionElementState() {
        if (this.hasAnimated) {
            return;
        }

        const motionElement = this.querySelector('motion-element');
        if (!motionElement) {
            return;
        }

        // 检查motion-element是否已经初始化（动画开始）
        if (motionElement.hasAttribute('data-initialized')) {
            this.hasAnimated = true;
            this.startAnimation();
        } else {
        }
    }

    startAnimation() {

        if (!this.numberContainer) {
            return;
        }

        if (this.number === 0) {
            return;
        }

        this.createRollingNumber(this.number, this.numberContainer);
    }

    easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
    }

    createRollingNumber(number, container) {
        const numStr = number.toLocaleString('en-US');
        const pureDigits = number.toString();
        const digitCount = pureDigits.length;

        // 获取当前元素的font-size值
        const computedStyle = window.getComputedStyle(container);
        const digitHeight = Math.round(parseFloat(computedStyle.fontSize));

        this.style.setProperty('--font-size', digitHeight + 'px');

        const totalDigits = 10;
        const duration = 2000;

        const wrapper = document.createElement('div');
        wrapper.className = 'rolling-number';

        const digitInners = [];
        let digitIndex = 0;

        for (const char of numStr) {
            if (char === ',') {
                const comma = document.createElement('div');
                comma.className = 'comma';
                comma.textContent = ',';
                wrapper.appendChild(comma);
            } else {
                const digit = parseInt(char);
                const digitBox = document.createElement('div');
                digitBox.className = 'digit';
                digitBox.setAttribute('data-last-number', digit); // 添加最终数值属性

                const inner = document.createElement('div');
                inner.className = 'digit-inner';

                const rolls = digitCount - digitIndex;

                for (let r = 0; r < rolls; r++) {
                    for (let i = 0; i < totalDigits; i++) {
                        const span = document.createElement('span');
                        span.textContent = i;
                        inner.appendChild(span);
                    }
                }

                const finalSpan = document.createElement('span');
                finalSpan.textContent = digit;
                inner.appendChild(finalSpan);

                digitBox.appendChild(inner);
                wrapper.appendChild(digitBox);

                digitInners.push({
                    inner,
                    offset: rolls * totalDigits * digitHeight
                });

                digitIndex++;
            }
        }

        // 清空数字容器内容，但保留unit元素
        const unitElement = container.querySelector('.unit');
        container.innerHTML = '';
        container.appendChild(wrapper);
        
        // 如果之前有unit元素，重新添加回来
        if (unitElement) {
            container.appendChild(unitElement);
        }

        const startTime = performance.now();
        const animate = (time) => {
            const elapsed = time - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = this.easeOutCubic(progress);

            digitInners.forEach(({ inner, offset }) => {
                inner.style.transform = `translateY(-${eased * offset}px)`;
            });

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                if (this.unitContainer) {
                    this.unitContainer.classList.add('active');
                }
            }
        };

        requestAnimationFrame(animate);
    }
}

customElements.define("scroll-number", ScrollNumber);
